export const flattenObj = (obj: Record<string, any>) => {
    let result = {} as Record<string, string>;
    for (const i in obj) {
        if (typeof obj[i] === "object" && !Array.isArray(obj[i])) {
            const temp = flattenObj(obj[i]);
            for (const j in temp) {
                result[i + (j === "__v" ? "" : "." + j)] = temp[j];
            }
        } else {
            result[i] = obj[i];
        }
    }
    return result;
};
